function ConversationList({ conversaciones, activa, userId, contactNames, onSelect }) {
  const getOtroId = (conversationId) => {
    const partes = conversationId.split("#")
    return partes.find(id => id !== userId) || partes[partes.length - 1]
  }

  const formatTime = (timestamp) => {
    if (!timestamp) return ""
    const d = new Date(timestamp)
    const now = new Date()
    const isToday = d.toDateString() === now.toDateString()
    return isToday
      ? d.toLocaleTimeString("es-ES", { hour: "2-digit", minute: "2-digit" })
      : d.toLocaleDateString("es-ES", { day: "2-digit", month: "2-digit" })
  }

  return (
    <div className="conversation-list">
      {conversaciones.length === 0 && (
        <div className="empty-list">
          <div className="empty-list-icon">💬</div>
          <p>Sin conversaciones aún</p>
          <p className="empty-list-hint">Pulsa + para empezar</p>
        </div>
      )}
      {conversaciones.map(conv => {
        const otroId = getOtroId(conv.conversationId)
        const nombre = contactNames?.[otroId] || otroId
        const inicial = nombre?.[0]?.toUpperCase() || "?"
        const estaActiva = activa === conv.conversationId

        return (
          <div
            key={conv.conversationId}
            className={`conversation-item ${estaActiva ? "active" : ""}`}
            onClick={() => onSelect(conv.conversationId)}
          >
            <div className="conv-avatar">{inicial}</div>
            <div className="conv-info">
              <div className="conv-top">
                <span className="conv-name">{nombre}</span>
                {conv.timestamp && (
                  <span className="conv-time">{formatTime(conv.timestamp)}</span>
                )}
              </div>
              <p className="conv-preview">
                {conv.ultimoMensaje || <em>Sin mensajes aún</em>}
              </p>
            </div>
          </div>
        )
      })}
    </div>
  )
}

export default ConversationList
